import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsGraphHistoryRedo;
(function (NsGraphHistoryRedo) {
    /** Command: 用于注册named factory */
    NsGraphHistoryRedo.command = XFlowGraphCommands.GRAPH_HISTORY_REDO;
    /** hookName */
    NsGraphHistoryRedo.hookKey = 'historyRedo';
})(NsGraphHistoryRedo || (NsGraphHistoryRedo = {}));
let GraphHistoryRedoCommand = 
/** 创建节点命令 */
class GraphHistoryRedoCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.historyRedo.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                if (graph.isHistoryEnabled() === false) {
                    return {
                        err: 'history is disabled',
                    };
                }
                graph.redo();
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    const { commandService } = handlerArgs;
                    commandService.executeCommand(XFlowGraphCommands.GRAPH_HISTORY_UNDO.id, {});
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphHistoryRedoCommand.prototype, "contextProvider", void 0);
GraphHistoryRedoCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphHistoryRedo.command.id },
    })
    /** 创建节点命令 */
], GraphHistoryRedoCommand);
export { GraphHistoryRedoCommand };
//# sourceMappingURL=graph-history-redo.js.map